// extracted by mini-css-extract-plugin
export default {"logo":"bca","cancel":"cca","stickyheader":"eca","buttonswrap":"fca","item":"gca","starterKit":"hca","boldHeader":"ica","reviewheader":"jca","text":"kca","username":"lca"};
    if(module.hot) {
      // 1743628931551
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  